import script from "./MobileDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileDetail.vue?vue&type=script&lang=ts&setup=true"

import "./MobileDetail.vue?vue&type=style&index=0&id=f70859c2&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f70859c2"]])

export default __exports__